import React, { useState } from "react";
import { HtmlReactParser } from "@kaltura/mediaspace-shared-utils";
import { Alert } from "@kaltura/ds-react-components";
import styled from "@emotion/styled";
import { generalHtmlStyles } from "@kaltura/mediaspace-shared-ui";

export interface BoardMessagesProps {
    boardMessages: {
        id: number;
        message: string;
        allowDismiss: boolean;
    }[];
    categoryName: string;
    categoryId: number;
}

const StyledBoardMessages = styled("ul")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    rowGap: theme.spacing(2),
    margin: theme.spacing(0),
    padding: theme.spacing(0),
}));

const StyledLi = styled("li")(({ theme }) => ({
    display: "inline",
}));

const StyledAlert = styled(Alert)(({ theme }) => [
    generalHtmlStyles(theme),
    {
        "& .board-message-text": { color: theme.kaltura.palette.tone1 },
    },
]);

const CHANNEL_NAME_PATTERN = "{CHANNEL_NAME}";

/**
 * Category message board - display list of messages
 */
const BoardMessages = (props: BoardMessagesProps) => {
    const { boardMessages, categoryName, categoryId } = props;

    const dismissedMessages = JSON.parse(localStorage.getItem("channelBoardMessages_" + categoryId) || "[]");
    const [shownMessages, setShownMessages] = useState<
        {
            id: number;
            message: string;
            allowDismiss: boolean;
        }[]
    >(boardMessages.filter((message) => !dismissedMessages.includes(message.id)));

    const handleHide = (messageId: number) => {
        const messagesToHide = JSON.parse(localStorage.getItem("channelBoardMessages_" + categoryId) || "[]");
        messagesToHide.push(messageId);
        localStorage.setItem("channelBoardMessages_" + categoryId, JSON.stringify(messagesToHide));
        setShownMessages((prev) => prev.filter((message) => message.id !== messageId));
    };
    return (
        shownMessages
        && shownMessages.length > 0 && (
            <StyledBoardMessages className={"kms-ds-channel-page-board-messages"}>
                {shownMessages.map((boardMessage) => {
                    const message = boardMessage.message.replace(CHANNEL_NAME_PATTERN, categoryName);
                    return (
                        <StyledLi key={boardMessage.id}>
                            <StyledAlert
                                classes={{ message: "board-message-text" }}
                                severity={"info"}
                                onClose={boardMessage.allowDismiss ? () => handleHide(boardMessage.id) : undefined}
                            >
                                <span>{HtmlReactParser(message)}</span>
                            </StyledAlert>
                        </StyledLi>
                    );
                })}
            </StyledBoardMessages>
        )
    );
};

export default BoardMessages;
